module.exports = __webpack_public_path__ + "img/type2.a9b6fab0.svg";